/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgCheckboxMixed16 = (props: Props) => (
  <Icon viewBox="0 0 16 16" {...props}>
    <path
      d="M14 0a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2zm0 1.33H2c-.37 0-.67.3-.67.67v12c0 .37.3.67.67.67h12c.37 0 .67-.3.67-.67V2c0-.37-.3-.67-.67-.67zM12 7v2H4V7z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgCheckboxMixed16 as CheckboxMixed16 };
